import { createSlice } from "@reduxjs/toolkit";
import { logInSuccess, signOutSuccess } from "src/modules/auth/duck/actions";

const initialState = {
  monitoringsById: {},
  dismissedAfterFirstMediaCaptureDialog: false,
  openedDescription: false,
  storageId: null,
  noiseCapture: "audio_photo",
  motionCapture: "video"
};

const activityLogSlice = createSlice({
  initialState,
  name: "activityLog",
  reducers: {
    monitoringStarted(state, { payload }) {
      payload.isStructureUploaded = false;
      state.monitoringsById[payload.monitoringId] = payload;
    },
    monitoringEnded(state, { payload }) {
      if (state.monitoringsById[payload.monitoringId]) {
        Object.assign(state.monitoringsById[payload.monitoringId], payload);
      }
    },
    monitoringUploaded(state, { payload }) {
      state.monitoringsById[payload].isStructureUploaded = true;
    },
    eventEnded(state, { payload }) {
      if (payload.event.fileName) payload.event.isMediaUploaded = false;
      else payload.event.isMediaUploaded = true;

      if (state.monitoringsById[payload.monitoringId]) {
        state.monitoringsById[payload.monitoringId].events.push(payload.event);
      }
    },
    eventMediaUploaded(state, { payload }) {
      if (state.monitoringsById[payload.monitoringId]) {
        const event = state.monitoringsById[payload.monitoringId].events.find(
          (event) => event.fileName === payload.fileName
        );
        if (event) event.isMediaUploaded = true;
      }
    },
    deleteMonitoring(state, { payload }) {
      delete state.monitoringsById[payload];
    },
    dismissedAfterFirstMediaCaptureDialog(state) {
      state.dismissedAfterFirstMediaCaptureDialog = true;
    },
    openedDescription(state) {
      state.openedDescription = true;
    },
    updateStorageId(state, { payload }) {
      state.storageId = payload;
    },
    updateNoiseCapture(state, { payload }) {
      state.noiseCapture = payload;
    },
    updateMotionCapture(state, { payload }) {
      state.motionCapture = payload;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(logInSuccess, (state) => {
        state.monitoringsById = {};
      })
      .addCase(signOutSuccess, () => {
        return initialState;
      });
  }
});

export { activityLogSlice };
export default activityLogSlice.reducer;
